export const getDaysLeftAmount = (weeksAmount: number, currentWeek: number, currentDay: number) => {
	const overallDays = weeksAmount * 7
	const daysLeft = overallDays - ((currentWeek - 1) * 7 + currentDay)
	return daysLeft >= 0 ? daysLeft : 0
}
